import { EmrState, HubFeature } from '@ats/api/cm';
import { LocDef, LocDefs, LocDisplayType, LocMap, MapLocKeys } from '../../models';
import { SYSTEM_ENUM_ROOT, SYSTEM_ENUM_TYPE } from '../shared-data';

const dpRoot = `${SYSTEM_ENUM_ROOT}|Email Request State|`;

type SharedKeys = Pick<
	LocDef,
	'type' | 'portal' | 'displayType' | 'htmlAllowed' | 'portal' | 'shared' | 'feature'
>;

const sharedLocData: Pick<LocDef, 'displayType' | 'htmlAllowed' | 'shared'> = {
	displayType: `${SYSTEM_ENUM_TYPE}` as LocDisplayType,
	htmlAllowed: false,
	shared: true,
};

const sharedSpLocData: SharedKeys = {
	...sharedLocData,
	portal: 'SP',
	feature: HubFeature.Core,
};

const sharedCpLocData: SharedKeys = {
	...sharedLocData,
	portal: 'CP',
	feature: HubFeature.CandidateAccess,
};

export type SPEmrStateLocs = `SPEmrStateEnum${EmrState}`;

export const spEmrStateEnumLocs: LocDefs<SPEmrStateLocs> = {
	SPEmrStateEnumComplete: {
		defaultValue: 'Completed',
		displayPath: `${dpRoot}${EmrState.Complete}`,
		description: `System value for '${EmrState.Complete}' email request state`,
		...sharedSpLocData,
	},
	SPEmrStateEnumError: {
		defaultValue: 'Error',
		displayPath: `${dpRoot}${EmrState.Error}`,
		description: `System value for '${EmrState.Error}' email request state`,
		...sharedSpLocData,
	},
	SPEmrStateEnumQueued: {
		defaultValue: 'Queued',
		displayPath: `${dpRoot}${EmrState.Queued}`,
		description: `System value for '${EmrState.Queued}' email request state`,
		...sharedSpLocData,
	},
	SPEmrStateEnumRejected: {
		defaultValue: 'Rejected',
		displayPath: `${dpRoot}${EmrState.Rejected}`,
		description: `System value for '${EmrState.Rejected}' email request state`,
		...sharedSpLocData,
	},
	SPEmrStateEnumRequested: {
		defaultValue: 'Requested',
		displayPath: `${dpRoot}${EmrState.Requested}`,
		description: `System value for '${EmrState.Requested}' email request state`,
		...sharedSpLocData,
	},
};

export type CPEmrStateLocs = `CPEmrStateEnum${EmrState}`;

export const cpEmrStateEnumLocs: LocDefs<CPEmrStateLocs> = {
	CPEmrStateEnumComplete: {
		defaultValue: 'Complete',
		displayPath: `${dpRoot}${EmrState.Complete}`,
		description: `System value for '${EmrState.Complete}' email request state`,
		...sharedCpLocData,
	},
	CPEmrStateEnumError: {
		defaultValue: 'Error',
		displayPath: `${dpRoot}${EmrState.Error}`,
		description: `System value for '${EmrState.Error}' email request state`,
		...sharedCpLocData,
	},
	CPEmrStateEnumQueued: {
		defaultValue: 'Queued',
		displayPath: `${dpRoot}${EmrState.Queued}`,
		description: `System value for '${EmrState.Queued}' email request state`,
		...sharedCpLocData,
	},
	CPEmrStateEnumRejected: {
		defaultValue: 'Rejected',
		displayPath: `${dpRoot}${EmrState.Rejected}`,
		description: `System value for '${EmrState.Rejected}' email request state`,
		...sharedCpLocData,
	},
	CPEmrStateEnumRequested: {
		defaultValue: 'Requested',
		displayPath: `${dpRoot}${EmrState.Requested}`,
		description: `System value for '${EmrState.Requested}' email request state`,
		...sharedCpLocData,
	},
};

export const EX_AP_REVIEW_STATE_ENUM_LOCS = MapLocKeys<SPEmrStateLocs | CPEmrStateLocs>({
	...spEmrStateEnumLocs,
	...cpEmrStateEnumLocs,
});

export type SPEmrStateEnumLocType = LocMap<SPEmrStateLocs>;
export type CPEmrStateEnumLocType = LocMap<CPEmrStateLocs>;

export const spEmrStateKeys: {
	[key in EmrState]: keyof SPEmrStateEnumLocType;
} = {
	[EmrState.Complete]: EX_AP_REVIEW_STATE_ENUM_LOCS.SPEmrStateEnumComplete,
	[EmrState.Error]: EX_AP_REVIEW_STATE_ENUM_LOCS.SPEmrStateEnumError,
	[EmrState.Queued]: EX_AP_REVIEW_STATE_ENUM_LOCS.SPEmrStateEnumQueued,
	[EmrState.Rejected]: EX_AP_REVIEW_STATE_ENUM_LOCS.SPEmrStateEnumRejected,
	[EmrState.Requested]: EX_AP_REVIEW_STATE_ENUM_LOCS.SPEmrStateEnumRequested,
};

export const cpEmrStateKeys: {
	[key in EmrState]: keyof CPEmrStateEnumLocType;
} = {
	[EmrState.Complete]: EX_AP_REVIEW_STATE_ENUM_LOCS.CPEmrStateEnumComplete,
	[EmrState.Error]: EX_AP_REVIEW_STATE_ENUM_LOCS.CPEmrStateEnumError,
	[EmrState.Queued]: EX_AP_REVIEW_STATE_ENUM_LOCS.CPEmrStateEnumQueued,
	[EmrState.Rejected]: EX_AP_REVIEW_STATE_ENUM_LOCS.CPEmrStateEnumRejected,
	[EmrState.Requested]: EX_AP_REVIEW_STATE_ENUM_LOCS.CPEmrStateEnumRequested,
};
